import type { ModuleStatus, ModuleVisibility } from '../schemas';
import styles from './Badge.module.css';

interface BadgeProps {
  readonly variant: ModuleStatus | ModuleVisibility;
  readonly children: string;
}

export function Badge({ variant, children }: BadgeProps) {
  return <span className={`${styles.badge} ${styles[variant]}`}>{children}</span>;
}
